// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FacebookOutlinedSvg from "@ant-design/icons-svg/es/asn/FacebookOutlined";
import AntdIcon from '../components/AntdIcon';

var FacebookOutlined = function FacebookOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FacebookOutlinedSvg
  }));
};

FacebookOutlined.displayName = 'FacebookOutlined';
export default React.forwardRef(FacebookOutlined);